import { render, staticRenderFns } from "./PressContacts.vue?vue&type=template&id=8d6b731e&scoped=true&"
import script from "./PressContacts.vue?vue&type=script&lang=js&"
export * from "./PressContacts.vue?vue&type=script&lang=js&"
import style0 from "./PressContacts.vue?vue&type=style&index=0&id=8d6b731e&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6b731e",
  null
  
)

export default component.exports